import React, { PropsWithChildren, createContext } from "react";
import { SiteSettings } from "../../carlsberg-headless/types/Site";
import { Cultures } from "../../carlsberg-headless/types/Culture";
import { LinkCollection } from "../../carlsberg-headless/types/LinkCollection";
import { TaxonomiesField } from "../../carlsberg-headless/types/fields/Taxonomies";

export interface SiteProviderAPI {
  settings: SiteSettings;
  cultures: Cultures;
  currentCulture: string;
  currentFrontpageUrl: string;
  cultureSelector: LinkCollection;
  bookTicketLink: LinkCollection;
  buyGiftcardLink: LinkCollection;
  apiKeys: Record<string, string>;
  pageTaxonomies: TaxonomiesField;
  hocFlavourIds: string[] | string | null;
  setHocFlavourIds: (flavourIds: string[]) => void;
}

export interface SiteProviderProps {
  data: {
    settings: SiteSettings;
    cultures: Cultures;
    currentCulture: string;
    cultureSelector: LinkCollection;
    bookTicketLink: LinkCollection;
    buyGiftcardLink: LinkCollection;
    pageTaxonomies: TaxonomiesField;
    hocFlavourIds: string[] | null;
  };
}

const initialContext: SiteProviderAPI = {
  currentCulture: "",
  cultures: {},
  cultureSelector: {} as LinkCollection,
  bookTicketLink: {} as LinkCollection,
  buyGiftcardLink: {} as LinkCollection,
  currentFrontpageUrl: "/",
  settings: {} as SiteSettings,
  apiKeys: {
    googleMapsApiKey: "AIzaSyBX4MshtLVcPY3kI7uel_-3ddcLSxAxIMs",
    carlsbergHeadlessApiKey: "a43d6bd2-4272-4cf5-b820-5dc106bc3562",
  },
  pageTaxonomies: [],
  hocFlavourIds: null,
  setHocFlavourIds: () => {},
};

const SiteContext = createContext<SiteProviderAPI>(initialContext);

const SiteProvider: React.FC<PropsWithChildren<SiteProviderProps>> = ({
  data,
  children,
}) => {
  const [hocFlavourIds, setFlavourIds] = React.useState<string[] | null>(null);
  const setHocFlavourIds = (flavourIds: string[]) => {
    setFlavourIds(flavourIds);
  };

  return (
    <SiteContext.Provider
      value={{
        ...initialContext,
        ...data,
        hocFlavourIds,
        setHocFlavourIds,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};

export { SiteProvider, SiteContext };
